<template>
  <div class="max-height-limit" ref="box" :class="{'hide': !isAllShow}">
    <div :style="{'maxHeight': (maxHeight && !isAllShow) ? maxHeight + 'px' : '' }">
      <div ref="mainHeight">
        <slot></slot>
      </div>
    </div>
    <template v-if="!hideBtn">
      <i class="el-icon-arrow-down" v-if="!isAllShow" @click="setAllShow()"></i>
      <i class="el-icon-arrow-up" v-if="isAllShow" @click="setAllShow()"></i>
    </template>
  </div>
</template>
<script>
import elementResizeDetectorMaker from "element-resize-detector";
export default {
  name: "maxHeightLimit",
  data() {
    return {
      hideBtn: false,
      isAllShow: false
    };
  },
  props: {
    maxHeight: {
      type: Number,
      default: 0
    }
  },
  methods: {
    setAllShow(key) {
       this.isAllShow = !this.isAllShow;
       setTimeout(() => {
        this.$emit('setHeight', this.$refs.box.offsetHeight)
       }, 0)
    },
    watchSize() {
      const _this = this;
      var erd = elementResizeDetectorMaker();
      erd.listenTo(this.$refs.mainHeight, (element) => { // 这里的this.$refs.fan指定要监听的元素对象，对应的是<div ref="fan"></div>
        _this.$nextTick(() => { // 这里填写监听改变后的操作
        let height = element.offsetHeight;
          if (height < (this.maxHeight || 50)) {
            this.hideBtn = true;
          } else {
            this.hideBtn = false;
          }
        });
      });
    }
  },
  mounted() {
    this.watchSize();
  }
};
</script>
<style lang="less" scoped>
.max-height-limit {
  position: relative;
  padding-right: 20px;
  &.hide {
    > div {
      overflow: hidden;
      max-height: 45px;
    }
  }
  > div {
    transition: all 0.2s;
    overflow: hidden;
  }
  > i {
    font-size: 16px;
    position: absolute;
    right: 2px;
    top: 12px;
    // margin-top: -8px;
    cursor: pointer;
  }
}
</style>
